var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cards"},[_c('div',{staticClass:"cards-item"},[_c('div',{staticClass:"cards-item-tit"},[_vm._v(_vm._s(_vm.cardsTit))]),_c('div',{staticClass:"cards-item-conter"},[_vm._t("cardsConter")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }